import { render, staticRenderFns } from "./SuggestionEtalon.vue?vue&type=template&id=14b46441&"
import script from "./SuggestionEtalon.vue?vue&type=script&lang=js&"
export * from "./SuggestionEtalon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports